import useLocation from '../hooks/useLocation';
import { useEffect } from 'react';
import mse from '@adobe/magento-storefront-events-sdk';
import { getPagetype } from '../util/getPageType';
var usePageView = () => {
  var location = useLocation();
  var pageType = getPagetype(location);
  useEffect(() => {
    mse.context.setPage({
      pageType
    });
    mse.publish.pageView();
  }, [location]);
};
export default usePageView;